import { TAGS } from "../constants/TagConstants";

export const getQuizTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (hours > 0 && minutes > 0) {
    return `${hours} hour ${minutes} min`;
  } else if (hours > 0) {
    return `${hours} hour`;
  } else {
    return `${minutes} min`;
  }
};

export const CheckOptionSerial = (index: number): string => {
  const options = ["a)", "b)", "c)", "d)"];
  return options[index] || "";
};

export const CheckTagColor = (tag: string): string | undefined => {
  if (tag && tag?.toLowerCase() === TAGS.Signal.name.toLowerCase()) {
    return TAGS.Signal.color;
  }
  if (tag && tag?.toLowerCase() === TAGS.Telecom.name.toLowerCase()) {
    return TAGS.Telecom.color;
  }
  if (tag && tag?.toLowerCase() === TAGS.Track.name.toLowerCase()) {
    return TAGS.Track.color;
  }
  return undefined;
};

interface OptionColorParams {
  data: {
    correct_answer: string;
    submit_answer?: string;
  };
  current_option: string;
}

export const CheckOptionColor = ({ data, current_option }: OptionColorParams): string => {
  const { correct_answer, submit_answer } = data;

  if (
    submit_answer &&
    submit_answer.toLowerCase().trim() === correct_answer.toLowerCase().trim()
  ) {
    if (
      current_option.toLowerCase().trim() ===
      correct_answer.toLowerCase().trim()
    ) {
      return "green";
    }
    return "black";
  }
  
  if (
    submit_answer &&
    current_option.toLowerCase().trim() === submit_answer.toLowerCase().trim()
  ) {
    return "red";
  }
  if (
    current_option.toLowerCase().trim() === correct_answer.toLowerCase().trim()
  ) {
    return "green";
  }
  return "black";
};

export const capitalize = (str: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};
